import { BRAND_COLORS } from "@bridgesplit/ui";

import { Overlay, OverlayConfig, SocialShareCardPalette, SocialShareVariant } from "./types";
import { Cheer, RainingMoney, Sunglasses, Disbelief, Fight, Strong, Smoke, Aged } from "./overlays";

export const SOCIAL_SHARE_PALETTES: Record<SocialShareVariant, SocialShareCardPalette> = {
    positive: {
        background: BRAND_COLORS.SKY,
        primary: BRAND_COLORS.BLUE,
        textPrimary: BRAND_COLORS.PRUSSIAN,
        textSecondary: BRAND_COLORS.GRAY,
        overlay: {
            primary: [BRAND_COLORS.BLUE, "#1E57A9", "#1E57A9"],
            secondary: BRAND_COLORS.PRUSSIAN,
            clothing: BRAND_COLORS.BLACK
        }
    },
    negative: {
        background: BRAND_COLORS.PINK,
        primary: BRAND_COLORS.ORANGE,
        textPrimary: BRAND_COLORS.PRUSSIAN,
        textSecondary: BRAND_COLORS.GRAY,

        overlay: {
            primary: [BRAND_COLORS.ORANGE, "#C94C0E", "#AD400B"],
            secondary: BRAND_COLORS.PINK,
            clothing: BRAND_COLORS.PRUSSIAN
        }
    }
};

export const OVERLAYS: OverlayConfig[] = [
    {
        id: "sunglasses",
        render: Sunglasses
    },
    {
        id: "cheer",
        render: Cheer
    },
    {
        id: "raining-money",
        render: RainingMoney
    },
    {
        id: "aged",
        render: Aged
    },
    {
        id: "fight",
        render: Fight
    },
    {
        id: "disbelief",
        render: Disbelief
    },
    {
        id: "strong",
        render: Strong
    },
    { id: "smoke", render: Smoke }
];

export const DEFAULT_OVERLAYS: Record<SocialShareVariant, Overlay> = {
    positive: "sunglasses",
    negative: "cheer"
};

export type SvgTextVariant = "headline" | "statLabel" | "statValue" | "positionName" | "positionTag";

export const SVG_TEXT_FILL: Record<SvgTextVariant, Exclude<keyof SocialShareCardPalette, "overlay">> = {
    headline: "primary",
    statLabel: "textSecondary",
    statValue: "textPrimary",
    positionName: "textPrimary",
    positionTag: "primary"
};

export const SVG_TEXT_SX: Record<SvgTextVariant, React.CSSProperties> = {
    headline: {
        fontSize: 180,
        fontWeight: 500,
        letterSpacing: "-0.03em"
    },
    statLabel: {
        fontSize: 24,
        fontWeight: 500
    },
    statValue: {
        fontSize: 32,
        fontWeight: "bold"
    },
    positionName: {
        fontSize: 28,
        fontWeight: 500
    },

    positionTag: {
        fontSize: 28,
        fontWeight: 500
    }
};

export const CARD_DIMS = {
    sm: {
        width: 368,
        height: 207
    },
    md: {
        width: 512,
        height: 288
    },
    lg: {
        width: 640,
        height: 360
    }
};

export const SOCIAL_SHARE_CARD = {
    WIDTH: 1200,
    HEIGHT: 675
};

export const DEFAULT_TWITTER_TEXT = "Earn the best yield on @Loopscale";
